import { motion } from 'framer-motion'
import React from 'react'
function Card(props) {
    const tourCard = {
        hidden: {
            opacity: 0
        },
        show: {
            opacity: 1,
        }
    }
    return (
        <div className="col l4 m6 s12">
            <motion.div
                variants={tourCard}
                initial="hidden"
                animate="show"
                transition={{ duration: 0.4, type: "spring" }}
                className="card medium hoverable">
                <div className="card-image waves-effect waves-block waves-light">
                    <img className="activator responsive-img" src={props.data.img} />
                </div>
                <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">{props.data.name}<i className="material-icons right">more_vert</i></span>
                    <p>
                        <button data-key='' onClick={()=>props.data.tourDelete(props.data.i)} className="btn red lighten-1">
                            <i className="material-icons">close</i>
                        </button>
                    </p>
                </div>
                <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4"><i className="material-icons right">close</i></span>
                    <p>
                        {props.data.description}
                    </p>
                </div>
            </motion.div>
        </div>
    )
}

export default Card
